import script from "./KCropper.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCropper.vue?vue&type=script&setup=true&lang=ts"

import "./KCropper.vue?vue&type=style&index=0&id=1a642697&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a642697"]])

export default __exports__